var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { style: { height: _vm.maxHeight, overflow: "auto" } },
    [
      _c(
        "el-row",
        [
          _c(
            "el-form",
            { attrs: { inline: true } },
            [
              _c(
                "el-form-item",
                { staticClass: "form-item" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        size: "mini",
                        icon: "el-icon-circle-plus-outline",
                      },
                      on: { click: _vm.addCalcField },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("dataset.add_calc_field")) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "form-item",
                  staticStyle: { float: "right", "margin-right": "0" },
                },
                [
                  _c("el-input", {
                    staticClass: "main-area-input",
                    attrs: {
                      size: "mini",
                      placeholder: _vm.$t("dataset.search"),
                      "prefix-icon": "el-icon-search",
                      clearable: "",
                    },
                    model: {
                      value: _vm.searchField,
                      callback: function ($$v) {
                        _vm.searchField = $$v
                      },
                      expression: "searchField",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-collapse",
        {
          staticClass: "style-collapse",
          model: {
            value: _vm.fieldActiveNames,
            callback: function ($$v) {
              _vm.fieldActiveNames = $$v
            },
            expression: "fieldActiveNames",
          },
        },
        [
          _c(
            "el-collapse-item",
            { attrs: { name: "d", title: _vm.$t("chart.dimension") } },
            [
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.tableFields.dimensionListData,
                    size: "mini",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      property: "name",
                      label: _vm.$t("dataset.field_name"),
                      width: "180",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-input", {
                              attrs: { size: "mini" },
                              on: {
                                blur: function ($event) {
                                  return _vm.saveEdit(scope.row)
                                },
                              },
                              nativeOn: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.saveEdit(scope.row)
                                },
                              },
                              model: {
                                value: scope.row.name,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "name", $$v)
                                },
                                expression: "scope.row.name",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      property: "deType",
                      label: _vm.$t("dataset.field_type"),
                      width: "140",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-select",
                              {
                                staticStyle: {
                                  display: "inline-block",
                                  width: "26px",
                                },
                                attrs: { size: "mini" },
                                on: {
                                  change: function ($event) {
                                    return _vm.saveEdit(scope.row)
                                  },
                                },
                                model: {
                                  value: scope.row.deType,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "deType", $$v)
                                  },
                                  expression: "scope.row.deType",
                                },
                              },
                              _vm._l(_vm.fields, function (item) {
                                return _c(
                                  "el-option",
                                  {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticStyle: { float: "left" } },
                                      [
                                        item.value === 0
                                          ? _c("svg-icon", {
                                              staticClass: "field-icon-text",
                                              attrs: {
                                                "icon-class": "field_text",
                                              },
                                            })
                                          : _vm._e(),
                                        item.value === 1
                                          ? _c("svg-icon", {
                                              staticClass: "field-icon-time",
                                              attrs: {
                                                "icon-class": "field_time",
                                              },
                                            })
                                          : _vm._e(),
                                        item.value === 2 || item.value === 3
                                          ? _c("svg-icon", {
                                              staticClass: "field-icon-value",
                                              attrs: {
                                                "icon-class": "field_value",
                                              },
                                            })
                                          : _vm._e(),
                                        item.value === 5
                                          ? _c("svg-icon", {
                                              staticClass:
                                                "field-icon-location",
                                              attrs: {
                                                "icon-class": "field_location",
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          float: "left",
                                          color: "#8492a6",
                                          "font-size": "12px",
                                        },
                                      },
                                      [_vm._v(_vm._s(item.label))]
                                    ),
                                  ]
                                )
                              }),
                              1
                            ),
                            _c(
                              "span",
                              { staticStyle: { "margin-left": "8px" } },
                              [
                                scope.row.deType === 0 || scope.row.deType === 6
                                  ? _c(
                                      "span",
                                      [
                                        scope.row.deType === 0 ||
                                        scope.row.deType === 6
                                          ? _c("svg-icon", {
                                              staticClass: "field-icon-text",
                                              attrs: {
                                                "icon-class": "field_text",
                                              },
                                            })
                                          : _vm._e(),
                                        _c(
                                          "span",
                                          { staticClass: "field-class" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("dataset.text"))
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                scope.row.deType === 1
                                  ? _c(
                                      "span",
                                      [
                                        scope.row.deType === 1
                                          ? _c("svg-icon", {
                                              staticClass: "field-icon-time",
                                              attrs: {
                                                "icon-class": "field_time",
                                              },
                                            })
                                          : _vm._e(),
                                        _c(
                                          "span",
                                          { staticClass: "field-class" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("dataset.time"))
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                scope.row.deType === 2 || scope.row.deType === 3
                                  ? _c(
                                      "span",
                                      [
                                        scope.row.deType === 2 ||
                                        scope.row.deType === 3
                                          ? _c("svg-icon", {
                                              staticClass: "field-icon-value",
                                              attrs: {
                                                "icon-class": "field_value",
                                              },
                                            })
                                          : _vm._e(),
                                        scope.row.deType === 2
                                          ? _c(
                                              "span",
                                              { staticClass: "field-class" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("dataset.value")
                                                  )
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        scope.row.deType === 3
                                          ? _c(
                                              "span",
                                              { staticClass: "field-class" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("dataset.value") +
                                                      "(" +
                                                      _vm.$t("dataset.float") +
                                                      ")"
                                                  )
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                scope.row.deType === 5
                                  ? _c(
                                      "span",
                                      [
                                        scope.row.deType === 5
                                          ? _c("svg-icon", {
                                              staticClass:
                                                "field-icon-location",
                                              attrs: {
                                                "icon-class": "field_location",
                                              },
                                            })
                                          : _vm._e(),
                                        _c(
                                          "span",
                                          { staticClass: "field-class" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("dataset.location"))
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      property: "deExtractType",
                      label: _vm.$t("dataset.origin_field_type"),
                      width: "100",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              scope.row.deExtractType === 0 ||
                              scope.row.deExtractType === 6
                                ? _c(
                                    "span",
                                    [
                                      scope.row.deExtractType === 0 ||
                                      scope.row.deExtractType === 6
                                        ? _c("svg-icon", {
                                            staticClass: "field-icon-text",
                                            attrs: {
                                              "icon-class": "field_text",
                                            },
                                          })
                                        : _vm._e(),
                                      _c(
                                        "span",
                                        { staticClass: "field-class" },
                                        [_vm._v(_vm._s(_vm.$t("dataset.text")))]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              scope.row.deExtractType === 1
                                ? _c(
                                    "span",
                                    [
                                      scope.row.deExtractType === 1
                                        ? _c("svg-icon", {
                                            staticClass: "field-icon-time",
                                            attrs: {
                                              "icon-class": "field_time",
                                            },
                                          })
                                        : _vm._e(),
                                      _c(
                                        "span",
                                        { staticClass: "field-class" },
                                        [_vm._v(_vm._s(_vm.$t("dataset.time")))]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              scope.row.deExtractType === 2 ||
                              scope.row.deExtractType === 3 ||
                              scope.row.deExtractType === 4
                                ? _c(
                                    "span",
                                    [
                                      scope.row.deExtractType === 2 ||
                                      scope.row.deExtractType === 3 ||
                                      scope.row.deExtractType === 4
                                        ? _c("svg-icon", {
                                            staticClass: "field-icon-value",
                                            attrs: {
                                              "icon-class": "field_value",
                                            },
                                          })
                                        : _vm._e(),
                                      scope.row.deExtractType === 2 ||
                                      scope.row.deExtractType === 4
                                        ? _c(
                                            "span",
                                            { staticClass: "field-class" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("dataset.value"))
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      scope.row.deExtractType === 3
                                        ? _c(
                                            "span",
                                            { staticClass: "field-class" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("dataset.value") +
                                                    "(" +
                                                    _vm.$t("dataset.float") +
                                                    ")"
                                                )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              scope.row.deExtractType === 5
                                ? _c(
                                    "span",
                                    [
                                      scope.row.deExtractType === 5
                                        ? _c("svg-icon", {
                                            staticClass: "field-icon-location",
                                            attrs: {
                                              "icon-class": "field_location",
                                            },
                                          })
                                        : _vm._e(),
                                      _c(
                                        "span",
                                        { staticClass: "field-class" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("dataset.location"))
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      property: "fromType",
                      label: _vm.$t("chart.form_type"),
                      width: "120",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.extField === 1
                              ? _c("span", { staticClass: "from-type-span" }, [
                                  _vm._v(_vm._s(_vm.$t("chart.copy_field"))),
                                ])
                              : _vm._e(),
                            scope.row.extField === 2
                              ? _c("span", { staticClass: "from-type-span" }, [
                                  _vm._v(_vm._s(_vm.$t("chart.calc_field"))),
                                ])
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c(
                    "el-table-column",
                    {
                      attrs: { property: "groupType", width: "120" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("el-button", {
                                attrs: {
                                  icon: "el-icon-sort",
                                  size: "mini",
                                  circle: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.dqTrans(scope.row, "d")
                                  },
                                },
                              }),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c(
                          "span",
                          { staticStyle: { "font-size": "12px" } },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("dataset.d_q_trans")) +
                                "\n              "
                            ),
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: { effect: "dark", placement: "bottom" },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    attrs: { slot: "content" },
                                    slot: "content",
                                  },
                                  [
                                    _vm._v(
                                      "\n                  若字段表达式中使用聚合函数，则字段不能设置为维度使用。\n                "
                                    ),
                                  ]
                                ),
                                _c("i", {
                                  staticClass: "el-icon-info",
                                  staticStyle: { cursor: "pointer" },
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    2
                  ),
                  _c("el-table-column", {
                    attrs: { property: "", label: _vm.$t("dataset.operator") },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.copyField(scope.row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("dataset.copy")) +
                                    "\n            "
                                ),
                              ]
                            ),
                            scope.row.extField !== 0
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text", size: "mini" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.editField(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("dataset.edit")) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            scope.row.extField !== 0
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text", size: "mini" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteField(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("dataset.delete")) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-collapse-item",
            { attrs: { name: "q", title: _vm.$t("chart.quota") } },
            [
              _c(
                "el-table",
                {
                  attrs: { data: _vm.tableFields.quotaListData, size: "mini" },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      property: "name",
                      label: _vm.$t("dataset.field_name"),
                      width: "180",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-input", {
                              attrs: { size: "mini" },
                              on: {
                                blur: function ($event) {
                                  return _vm.saveEdit(scope.row)
                                },
                              },
                              nativeOn: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.saveEdit(scope.row)
                                },
                              },
                              model: {
                                value: scope.row.name,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "name", $$v)
                                },
                                expression: "scope.row.name",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      property: "deType",
                      label: _vm.$t("dataset.field_type"),
                      width: "140",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-select",
                              {
                                staticStyle: {
                                  display: "inline-block",
                                  width: "26px",
                                },
                                attrs: { size: "mini" },
                                on: {
                                  change: function ($event) {
                                    return _vm.saveEdit(scope.row)
                                  },
                                },
                                model: {
                                  value: scope.row.deType,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "deType", $$v)
                                  },
                                  expression: "scope.row.deType",
                                },
                              },
                              _vm._l(_vm.fields, function (item) {
                                return _c(
                                  "el-option",
                                  {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticStyle: { float: "left" } },
                                      [
                                        item.value === 0
                                          ? _c("svg-icon", {
                                              staticClass: "field-icon-text",
                                              attrs: {
                                                "icon-class": "field_text",
                                              },
                                            })
                                          : _vm._e(),
                                        item.value === 1
                                          ? _c("svg-icon", {
                                              staticClass: "field-icon-time",
                                              attrs: {
                                                "icon-class": "field_time",
                                              },
                                            })
                                          : _vm._e(),
                                        item.value === 2 || item.value === 3
                                          ? _c("svg-icon", {
                                              staticClass: "field-icon-value",
                                              attrs: {
                                                "icon-class": "field_value",
                                              },
                                            })
                                          : _vm._e(),
                                        item.value === 5
                                          ? _c("svg-icon", {
                                              staticClass:
                                                "field-icon-location",
                                              attrs: {
                                                "icon-class": "field_location",
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          float: "left",
                                          color: "#8492a6",
                                          "font-size": "12px",
                                        },
                                      },
                                      [_vm._v(_vm._s(item.label))]
                                    ),
                                  ]
                                )
                              }),
                              1
                            ),
                            _c(
                              "span",
                              { staticStyle: { "margin-left": "8px" } },
                              [
                                scope.row.deType === 0
                                  ? _c(
                                      "span",
                                      [
                                        scope.row.deType === 0
                                          ? _c("svg-icon", {
                                              staticClass: "field-icon-text",
                                              attrs: {
                                                "icon-class": "field_text",
                                              },
                                            })
                                          : _vm._e(),
                                        _c(
                                          "span",
                                          { staticClass: "field-class" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("dataset.text"))
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                scope.row.deType === 1
                                  ? _c(
                                      "span",
                                      [
                                        scope.row.deType === 1
                                          ? _c("svg-icon", {
                                              staticClass: "field-icon-time",
                                              attrs: {
                                                "icon-class": "field_time",
                                              },
                                            })
                                          : _vm._e(),
                                        _c(
                                          "span",
                                          { staticClass: "field-class" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("dataset.time"))
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                scope.row.deType === 2 || scope.row.deType === 3
                                  ? _c(
                                      "span",
                                      [
                                        scope.row.deType === 2 ||
                                        scope.row.deType === 3
                                          ? _c("svg-icon", {
                                              staticClass: "field-icon-value",
                                              attrs: {
                                                "icon-class": "field_value",
                                              },
                                            })
                                          : _vm._e(),
                                        scope.row.deType === 2
                                          ? _c(
                                              "span",
                                              { staticClass: "field-class" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("dataset.value")
                                                  )
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        scope.row.deType === 3
                                          ? _c(
                                              "span",
                                              { staticClass: "field-class" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("dataset.value") +
                                                      "(" +
                                                      _vm.$t("dataset.float") +
                                                      ")"
                                                  )
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                scope.row.deType === 5
                                  ? _c(
                                      "span",
                                      [
                                        scope.row.deType === 5
                                          ? _c("svg-icon", {
                                              staticClass:
                                                "field-icon-location",
                                              attrs: {
                                                "icon-class": "field_location",
                                              },
                                            })
                                          : _vm._e(),
                                        _c(
                                          "span",
                                          { staticClass: "field-class" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("dataset.location"))
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      property: "deExtractType",
                      label: _vm.$t("dataset.origin_field_type"),
                      width: "100",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              scope.row.deExtractType === 0
                                ? _c(
                                    "span",
                                    [
                                      scope.row.deExtractType === 0
                                        ? _c("svg-icon", {
                                            staticClass: "field-icon-text",
                                            attrs: {
                                              "icon-class": "field_text",
                                            },
                                          })
                                        : _vm._e(),
                                      _c(
                                        "span",
                                        { staticClass: "field-class" },
                                        [_vm._v(_vm._s(_vm.$t("dataset.text")))]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              scope.row.deExtractType === 1
                                ? _c(
                                    "span",
                                    [
                                      scope.row.deExtractType === 1
                                        ? _c("svg-icon", {
                                            staticClass: "field-icon-time",
                                            attrs: {
                                              "icon-class": "field_time",
                                            },
                                          })
                                        : _vm._e(),
                                      _c(
                                        "span",
                                        { staticClass: "field-class" },
                                        [_vm._v(_vm._s(_vm.$t("dataset.time")))]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              scope.row.deExtractType === 2 ||
                              scope.row.deExtractType === 3 ||
                              scope.row.deExtractType === 4
                                ? _c(
                                    "span",
                                    [
                                      scope.row.deExtractType === 2 ||
                                      scope.row.deExtractType === 3 ||
                                      scope.row.deExtractType === 4
                                        ? _c("svg-icon", {
                                            staticClass: "field-icon-value",
                                            attrs: {
                                              "icon-class": "field_value",
                                            },
                                          })
                                        : _vm._e(),
                                      scope.row.deExtractType === 2 ||
                                      scope.row.deExtractType === 4
                                        ? _c(
                                            "span",
                                            { staticClass: "field-class" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("dataset.value"))
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      scope.row.deExtractType === 3
                                        ? _c(
                                            "span",
                                            { staticClass: "field-class" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("dataset.value") +
                                                    "(" +
                                                    _vm.$t("dataset.float") +
                                                    ")"
                                                )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              scope.row.deExtractType === 5
                                ? _c(
                                    "span",
                                    [
                                      scope.row.deExtractType === 5
                                        ? _c("svg-icon", {
                                            staticClass: "field-icon-location",
                                            attrs: {
                                              "icon-class": "field_location",
                                            },
                                          })
                                        : _vm._e(),
                                      _c(
                                        "span",
                                        { staticClass: "field-class" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("dataset.location"))
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      property: "fromType",
                      label: _vm.$t("chart.form_type"),
                      width: "120",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.extField === 1
                              ? _c("span", { staticClass: "from-type-span" }, [
                                  _vm._v(_vm._s(_vm.$t("chart.copy_field"))),
                                ])
                              : _vm._e(),
                            scope.row.extField === 2
                              ? _c("span", { staticClass: "from-type-span" }, [
                                  _vm._v(_vm._s(_vm.$t("chart.calc_field"))),
                                ])
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c(
                    "el-table-column",
                    {
                      attrs: { property: "groupType", width: "120" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("el-button", {
                                attrs: {
                                  icon: "el-icon-sort",
                                  size: "mini",
                                  circle: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.dqTrans(scope.row, "q")
                                  },
                                },
                              }),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c(
                          "span",
                          { staticStyle: { "font-size": "12px" } },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("dataset.d_q_trans")) +
                                "\n              "
                            ),
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: { effect: "dark", placement: "bottom" },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    attrs: { slot: "content" },
                                    slot: "content",
                                  },
                                  [
                                    _vm._v(
                                      "\n                  若字段表达式中使用聚合函数，则字段不能设置为维度使用。\n                "
                                    ),
                                  ]
                                ),
                                _c("i", {
                                  staticClass: "el-icon-info",
                                  staticStyle: { cursor: "pointer" },
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    2
                  ),
                  _c("el-table-column", {
                    attrs: { property: "", label: _vm.$t("dataset.operator") },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.copyField(scope.row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("dataset.copy")) +
                                    "\n            "
                                ),
                              ]
                            ),
                            scope.row.extField !== 0
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text", size: "mini" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.editField(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("dataset.edit")) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            scope.row.extField !== 0
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text", size: "mini" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteField(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("dataset.delete")) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.editCalcField
        ? _c(
            "el-dialog",
            {
              staticClass: "de-dialog-form de-center-dialog",
              attrs: {
                visible: _vm.editCalcField,
                width: "980px",
                title: _vm.currEditField.id
                  ? _vm.$t("dataset.edit_calc_field")
                  : _vm.$t("dataset.add_calc_field"),
                "append-to-body": "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.editCalcField = $event
                },
              },
            },
            [
              _c("calc-chart-field-edit", {
                attrs: {
                  param: _vm.param,
                  field: _vm.currEditField,
                  mode: _vm.currEditField.extField === 1 ? "copy" : "normal",
                },
                on: { onEditClose: _vm.closeCalcField },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }